export enum EstadosEquipos {
  Asignado = 'Asignado',
  NoAsignado = 'No Asignado',
  Principal = 'Principal',
  Backup = 'Backup',
  Baja = 'Baja',
  Vendido = 'Vendido',
  Robo = 'Robo',
  Stock = 'Stock',
  Vacio = '',
}
